import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import SaidasLayout from './saidas/saidaslayout';
import { quickExit } from '../services/api'; // Função de API para saída rápida
import FeedbackModal from './modals/FeedbackModal'; // Ajuste o caminho conforme necessário

const Saida = () => {
  const [barcode, setBarcode] = useState('');
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionComplete, setSubmissionComplete] = useState(false);
  const [feedbackError, setFeedbackError] = useState(null);

  const handleBarcodeSubmit = async () => {
    const scannedCode = barcode.trim();
    if (scannedCode) {
      setIsSubmitting(true);
      try {
        const response = await quickExit(scannedCode);
        console.log("Quick exit processed:", response.data);
        // Se o código for válido, não abre modal; apenas limpa o input e reabilita
        setBarcode('');
        setIsSubmitting(false);
      } catch (error) {
        console.error("Error processing quick exit:", error);
        let errMsg = "";
        if (error.response) {
          if (error.response.status === 404) {
            errMsg = "Código de barras inválido";
          } else if (error.response.status === 400) {
            errMsg = "Esse lote já está esgotado";
          } else if (error.response.data && error.response.data.error) {
            errMsg = error.response.data.error;
          } else {
            errMsg = "Erro ao processar a saída";
          }
        } else {
          errMsg = "Erro ao processar a saída";
        }
        setFeedbackError(errMsg);
        setFeedbackModalOpen(true);
        // Após 2 segundos, fecha a modal e limpa o campo, reabilitando o input
        setTimeout(() => {
          setFeedbackModalOpen(false);
          setBarcode('');
          setIsSubmitting(false);
          setFeedbackError(null);
        }, 2000);
      }
    }
  };

  const handleBarcodeKeyPress = async (e) => {
    if (e.key === 'Enter') {
      await handleBarcodeSubmit();
    }
  };

  return (
    <div style={{ padding: '16px' }}>
      <h5 style={{ textAlign: 'center', marginBottom: '16px' }}>Saída</h5>
      <InputText
        style={{ width: '40%', marginBottom: '16px' }}
        placeholder="Para uma rápida saída, pique aqui o código de barras ou QRcode"
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        onKeyPress={handleBarcodeKeyPress}
        disabled={isSubmitting}
      />
      <Button 
        label="Dar saída por artigo" 
        className="p-button p-button-primary" 
        onClick={handleBarcodeSubmit}
        style={{ marginBottom: '16px', marginLeft: '16px' }}
      />
      <SaidasLayout />
      <FeedbackModal 
        open={feedbackModalOpen}
        isSubmitting={isSubmitting}
        submissionComplete={submissionComplete}
        error={feedbackError}
        onClose={() => setFeedbackModalOpen(false)}
      />
    </div>
  );
};

export default Saida;
